import React from 'react'
import { LoaderIcon } from '../icons'
import { isEmpty } from 'lodash'

interface LoaderProps {
  isGlobal?: boolean
  className?: string
  loaderHeight?: string
  loaderWidth?: string
  loaderText?: string
  loaderSubText?: string
}

const Loader: React.FC<LoaderProps> = ({
  isGlobal = true,
  className,
  loaderHeight = '126',
  loaderWidth = '126',
  loaderText,
  loaderSubText,
}) => {
  return (
    <div
      id="global-loader"
      className={`flex items-center justify-center ${
        isGlobal ? 'min-h-screen' : ''
      } ${className} ${!isEmpty(loaderText) ? 'flex-col gap-2' : ''}`}
    >
      <div className=" border-opacity-50 rounded-full animate-[spin_1.69s_linear_infinite]">
        <LoaderIcon height={loaderHeight} width={loaderWidth} />
      </div>
      {(!isEmpty(loaderText) || !isEmpty(loaderSubText)) && (
        <div className="flex items-center justify-center flex-col text-center bg-accent-0">
          {!isEmpty(loaderText) && (
            <span className="font-medium">{loaderText}</span>
          )}
          {!isEmpty(loaderSubText) && (
            <span className="text-sm">{loaderSubText}</span>
          )}
        </div>
      )}
    </div>
  )
}

export default Loader
